import * as React from "react";
const SvgFiRrSubscriptionAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-subscription-alt_svg__a)">
      <path
        fill="#062147"
        d="M20.999 24c-.021 0 .02 0 0 0M19.5 0h-15A4.505 4.505 0 0 0 0 4.5v2C0 8.981 2.019 11 4.5 11H5a1 1 0 1 0 0-2h-.5A2.503 2.503 0 0 1 2 6.5v-2C2 3.122 3.121 2 4.5 2h15C20.879 2 22 3.122 22 4.5v2C22 7.878 20.879 9 19.5 9H17a1 1 0 1 0 0 2h2.5c2.481 0 4.5-2.019 4.5-4.5v-2C24 2.019 21.981 0 19.5 0m-.737 18.552-4.756-1.783v-4.662c0-1.516-1.076-2.834-2.504-3.066a3 3 0 0 0-2.439.674 3 3 0 0 0-1.057 2.286v7.563l-.999-.795a3 3 0 0 0-4.062 4.412l.558.538c.186.18.435.28.694.28.9 0 1.342-1.095.694-1.72l-.568-.548a1 1 0 0 1 1.355-1.471c.022.021 1.781 1.423 1.781 1.423.477.38 1.113.448 1.66.186a1.56 1.56 0 0 0 .888-1.415v-8.455c0-.294.129-.572.353-.762.228-.194.519-.271.822-.224.463.076.825.556.825 1.093v5.354c0 .417.259.79.648.937l5.404 2.027a3 3 0 0 1 1.942 2.633 1 1 0 0 0 .997.943c.551-.032 1.031-.508.999-1.059a5 5 0 0 0-3.235-4.389"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-subscription-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSubscriptionAlt;
